import React, { FC, useEffect } from 'react'
import { useToasts } from 'react-toast-notifications'

import { AbilityContext } from '../../CASL/Can'
import Ability from '../../CASL/Ability'

import { useDispatch, useSelector } from '../../store'
import { getMeThunk } from '../../store/auth/thunks'
import Routes from './routes'
import { hideGlobalPreloaderAction, showGlobalPreloaderAction } from '../../store/preloader/slice'
// import {
//   getSocialMediaRestrictionsThunk,
//   getSocialContentRestrictionsThunk
// } from '../../store/application/thunks'
import { TOAST_MESSAGE } from '../../components/UI/ToastNotification/ToastNotification'
import { appLogOutAction } from '../../store/auth/slice'

interface AppProps { }

const App: FC<AppProps> = () => {
  const token = localStorage.getItem('token')
  const dispatch = useDispatch()
  const user = useSelector((state) => state.auth.user)

  const { addToast } = useToasts()

  useEffect(() => {
    const getUserData = async () => {
      dispatch(showGlobalPreloaderAction())
      // TODO replace hardcoded restrictions and move them to places where it uses.
      // const restrictions = await Promise.all([dispatch(getSocialMediaRestrictionsThunk()), dispatch(getSocialContentRestrictionsThunk())])
      // console.log('globalRestrictions', { mediaRestrictions: restrictions[0], contentRestrictions: restrictions[1] })
      const responseGetMe = await dispatch(getMeThunk())
      dispatch(hideGlobalPreloaderAction())
    }
    if (user && user.is_blocked) {
      addToast(TOAST_MESSAGE.ACCOUNT_WAS_BLOCKED, { appearance: 'error' })
      dispatch(appLogOutAction())
    }
    if (!user && token) {
      getUserData()
    }
  }, [user, dispatch, token])

  return (
    <AbilityContext.Provider value={Ability(user)}>
      <Routes />
    </AbilityContext.Provider>
  )
}
export default App
